import React,{Component} from 'react';
import i18n from '../../i18n';
import Alert  from "@react/react-spectrum/Icon/Alert";
import Well from '@react/react-spectrum/Well';

class AppBumperComponent extends Component{
    render(){
        return(
            <Well>
                <div className="app-bumper">
                    <div className="center">
                            <span className="bumper-icon"><Alert size="XL" /></span>
                            <h3>{i18n.t('bumper.serviceDown.title')}</h3>
                            <div>
                                <p>{i18n.t('bumper.serviceDown.description')}</p>
                            </div>
                    </div>
                </div>
            </Well>
        )
    }
}

export default AppBumperComponent;